import { useSmartProp } from '@smartfire/js-block-engine';
import { EditableImg } from '@smartfire/components';
import { PanelBody, PanelRow, SelectControl, ToggleControl } from '@wordpress/components';

export const Inspector = () => {
    const [type, setType] = useSmartProp('type');
    const [isHeightFixed, setIsHeightFixed] = useSmartProp('isHeightFixed');

    return (
        <PanelBody title="Paramètres" initialOpen={true}>
            <PanelRow>
                <SelectControl
                    label="Type"
                    value={type}
                    onChange={setType}
                    options={[
                        { value: 'image', label: 'Image' },
                        { value: 'encart', label: 'Encart' },
                    ]}
                />
            </PanelRow>
            {type === 'image' && (
                <>
                    <label>Image</label>
                    <PanelRow label="Image">
                        <EditableImg smartProp={'image'} />
                    </PanelRow>
                    <PanelRow>
                        <ToggleControl checked={isHeightFixed} onChange={setIsHeightFixed} label={'Hauteur fixe'} />
                    </PanelRow>
                </>
            )}
        </PanelBody>
    );
};

export default Inspector;
